import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      position="top-right"
      expand={true}
      richColors={true}
      closeButton={true}
      duration={5000}
      className="toaster group"
      style={{
        '--normal-bg': '#ffffff',
        '--normal-border': '#e5e7eb',
        '--normal-text': '#1f2937',
        '--success-bg': '#10B981',
        '--success-border': '#10B981',
        '--success-text': '#ffffff',
        '--error-bg': '#FEF2F2',
        '--error-border': '#EF4444',
        '--error-text': '#DC2626',
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border-2 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-[0px_6px_20px_rgba(0,0,0,0.12)] group-[.toaster]:rounded-xl group-[.toaster]:p-4 group-[.toaster]:min-w-[380px]",
          title: "group-[.toast]:text-base group-[.toast]:font-semibold group-[.toast]:text-gray-900",
          description: "group-[.toast]:text-gray-600 group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-[#059669] group-[.toast]:text-white group-[.toast]:font-semibold group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:rounded-lg group-[.toast]:text-sm",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-700",
          success: "group-[.toaster]:!bg-[#10B981] group-[.toaster]:!text-white group-[.toaster]:border-[#10B981] [&_[data-title]]:!text-white [&_[data-description]]:!text-white/90",
          error: "group-[.toaster]:!bg-[#FEF2F2] group-[.toaster]:!border-[#EF4444] [&_[data-title]]:!text-[#DC2626] [&_[data-description]]:!text-[#DC2626]/80",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
